import { endpoints } from '@/config';
import api from './api';

let last;
export function getLast() {
  return last;
}

/**
   * Fetch all KPIs that belong to the current account from the API
   *
   * @returns Promise
   */
export function getKpis() {
  const endpoint = endpoints.kpis;
  return api.get(endpoint).then((response) => {
    last = response.data;
    return Promise.resolve(response.data);
  });
}

/**
   * Create a KPI using the data passed in, should be in the format:
   * {
   *   name: "test",
   *   kpi: {
   *     op: "now"
   *   }
   * }
   *
   * @param {Object} args
   * @returns
   */
export function createKpi(args) {
  last = undefined;
  const endpoint = endpoints.kpis;

  if (!args || !args.name) {
    return Promise.reject(new Error('Data must be passed in to create a KPI'));
  }
  delete args.$id; // eslint-disable-line no-param-reassign

  return api.post(endpoint, args).then(((response) => Promise.resolve(response.data)));
}

export function updateKpi(args) {
  last = undefined;
  if (!args.$id) {
    return createKpi(args);
  }

  const endpoint = `${endpoints.kpis}/${args.$id}`;
  return api.put(endpoint, args).then(((response) => Promise.resolve(response.data)));
}

export function deleteKpi(id) {
  last = undefined;
  if (!id) {
    return Promise.reject(new Error('An ID must be supplied to delete a KPI'));
  }

  const endpoint = `${endpoints.kpis}/${id}`;
  return api.delete(endpoint).then(() => Promise.resolve());
}
